import {
  validateOrderNoteCondition,
  type OrderNoteState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { memo } from "react";

export const OrderNoteDetails = memo(function OrderNoteDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<OrderNoteState>) {
  const validation = validateOrderNoteCondition(state);

  return (
    <RedoTextInput
      errorText={validation.valid ? undefined : validation.errors[0]}
      label="Order note contains"
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          event.stopPropagation();
        }
      }}
      placeholder="Enter text to match"
      required
      setValue={(value) => setState(value)}
      size="sm"
      state={disabled ? "disabled" : validation.valid ? "default" : "error"}
      value={state}
    />
  );
});
